<template>
  <div class="incentive-root">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow05.png" alt="" />
        </template>
      </van-nav-bar>
    </div>
    <img class="content-img" src="./images/content-img.png" style="width: 100%" :style="{ 'margin-top': `-${barHeight * 1 + 46}px` }" />
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.incentive-root {
  .custom-nav-block {
    background-color: transparent;
  }
}
</style>
